"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyShareWorkspaceResourceV1WorkspaceResourcesResourceIdSharePostRole = void 0;
exports.BodyShareWorkspaceResourceV1WorkspaceResourcesResourceIdSharePostRole = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
